import { render, staticRenderFns } from "./sqlReports.pug?vue&type=template&id=5b2a824b&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./sqlReports.scss?vue&type=style&index=0&id=5b2a824b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a824b",
  null
  
)

export default component.exports